
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import BookingPage from '../pages/booking/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
